import React, { useEffect, useState } from 'react';
import { Input, Button, Popconfirm, Table, Form, Radio, InputNumber } from "antd";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const AllergyHistorie = (props) => {
    const { form } = props;
    const [occurrenceVisible, setOccurrenceVisible] = useState({});
    const allergyList = Form.useWatch('patient_allergy_info', form) || [];

    // Theo dõi toàn bộ thay đổi của danh sách dị ứng
    useEffect(() => {
        const visibleMap = {};
        allergyList.forEach((item, index) => {
            visibleMap[index] = item?.has_occurrence === "Có";
        });
        setOccurrenceVisible(visibleMap);
    }, [JSON.stringify(allergyList)]); // so sánh sâu để re-render khi dữ liệu đổi


    return (
        <div style={{ paddingBottom: 40 }}>
            <Form.List name="patient_allergy_info">
                {(fields, { add, remove }) => {
                    return (
                        <>
                            <Table
                                dataSource={fields}
                                columns={[
                                    {
                                        title: "STT",
                                        dataIndex: "key",
                                        width: '50px',
                                        align: "center",
                                        render: (_, record, index) => (
                                            <span>{index + 1}</span>
                                        )
                                    },
                                    {
                                        title: "Nội dung",
                                        dataIndex: "content",
                                        width: '250px',
                                        render: (_, record, index) => {
                                            const contentValue = form.getFieldValue(["patient_allergy_info", index, "content"]);
                                            const isNew = form.getFieldValue(["patient_allergy_info", index, "isNew"]);
                                            return (
                                                isNew ? (
                                                    <Form.Item name={[index, "content"]} rules={[{ required: false, message: "Bắt buộc nhập" }]}>
                                                        <Input.TextArea rows={2} placeholder='Nhập nội dung' />
                                                    </Form.Item>
                                                ) : (
                                                    <span>
                                                        {contentValue}
                                                        <Form.Item name={[index, "content"]} initialValue={contentValue} hidden>
                                                            <Input />
                                                        </Form.Item>
                                                    </span>
                                                )
                                            )
                                        }
                                    },
                                    {
                                        title: "Tên thuốc, dị nguyên",
                                        dataIndex: "allergen_name",
                                        width: '300px',
                                        render: (_, record, index) => (
                                            <Form.Item name={[index, "allergen_name"]} rules={[{ required: false, message: "Bắt buộc nhập" }]}>
                                                <Input.TextArea rows={2} placeholder="Nhập tên thuốc, dị nguyên" />
                                            </Form.Item>
                                        )
                                    },
                                    {
                                        title: "Dị ứng?",
                                        width: '100px',
                                        render: (_, __, index) => (
                                            <Form.Item name={[index, "has_occurrence"]}>
                                                <Radio.Group
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const currentList = form.getFieldValue("patient_allergy_info") || [];
                                                        const updated = [...currentList];

                                                        if (value === "Không") {
                                                            // Khi chọn "Không" → xóa số lần & ẩn ô nhập
                                                            updated[index] = {
                                                                ...updated[index],
                                                                has_occurrence: "Không",
                                                                occurrence_count: null,
                                                            };
                                                        } else {
                                                            updated[index] = {
                                                                ...updated[index],
                                                                has_occurrence: "Có",
                                                            };
                                                        }

                                                        form.setFieldsValue({ patient_allergy_info: updated });
                                                        setOccurrenceVisible((prev) => ({
                                                            ...prev,
                                                            [index]: value === "Có",
                                                        }));
                                                    }}
                                                >
                                                    <Radio value="Có">Có</Radio>
                                                    <Radio value="Không">Không</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        ),
                                    },
                                    {
                                        title: "Số lần",
                                        dataIndex: "occurrence_count",
                                        width: '150px',
                                        render: (_, record, index) => (
                                            occurrenceVisible[index] && (
                                                <Form.Item name={[index, "occurrence_count"]} rules={[{ required: true, message: "Bắt buộc nhập" }]}>
                                                    <InputNumber min={1} className='w-100' placeholder="Nhập số lần" />
                                                </Form.Item>
                                            )
                                        )
                                    },
                                    {
                                        title: "Biểu hiện lâm sàng - xử trí",
                                        dataIndex: "clinical_signs",
                                        width: '300px',
                                        render: (_, record, index) => (
                                            <Form.Item name={[index, "clinical_signs"]} rules={[{ required: false, message: "Bắt buộc nhập" }]}>
                                                <Input.TextArea rows={2} placeholder="Nhập biểu hiện lâm sàng" />
                                            </Form.Item>
                                        )
                                    },
                                    {
                                        title: "#",
                                        dataIndex: "actions",
                                        width: '30px',
                                        align: "center",
                                        render: (_, __, index) => (
                                            <Popconfirm
                                                title="Xóa dòng này?"
                                                onConfirm={() => remove(index)}
                                                placement="topLeft"
                                            >
                                                <DeleteOutlined className='delete-icon' />
                                            </Popconfirm>
                                        )
                                    }
                                ]}
                                rowKey={(record, index) => index}
                                pagination={false}
                                size='small'
                                bordered={false}
                                scroll={{
                                    x: 'max-content'
                                }}
                                locale={{ emptyText: "Chưa có dữ liệu" }}
                            />
                            <Button
                                type="primary"
                                size='default'
                                className='w-100'
                                onClick={() => add({
                                    content: "",
                                    allergen_name: "",
                                    occurrence_count: "",
                                    has_occurrence: "no",
                                    clinical_signs: "",
                                    isNew: true
                                })}
                                icon={<PlusOutlined />}
                            >
                                Thêm dòng mới
                            </Button>
                        </>
                    )
                }}
            </Form.List>
        </div>
    );
};

export default AllergyHistorie;
